<template>
  <li v-if="props.option.label">
    <span
      :class="DS_OPTION_LIST_CLASSES.groupItem"
      :data-cy="`ds-option-list__group-title--${convertStringToDataCy(props.option.label)}`"
    >
      {{ props.option.label }}
    </span>

    <ul :class="DS_OPTION_LIST_CLASSES.groupOptions">
      <DSOptionListItem
        v-for="listOption in props.option.options"
        :key="listOption.value || 'null'"
        v-model="modelValue"
        :option="listOption"
        :disabled="props.disabled"
        :multiple="props.multiple"
        :option-id="getOptionId(props.listId || '', listOption)"
        :active="isOptionActive(listOption)"
      >
        <template
          v-if="hasSuffixSlot"
          #suffix="slotProps"
        >
          <slot
            name="suffix"
            v-bind="slotProps"
          />
        </template>
      </DSOptionListItem>
    </ul>
  </li>
</template>

<script setup lang="ts">
import { computed, useSlots } from "vue";
import { DSBaseListOption, DSOptionListGroupItemProps, DSOptionListModelValue } from "../types";
import { convertStringToDataCy } from "@/src/shared/utils/playwright";
import DSOptionListItem from "@/src/design_system/form_elements/option_list/components/DSOptionListItem.vue";
import { DS_OPTION_LIST_CLASSES } from "@/src/design_system/form_elements/option_list/constants/classes";
import { getOptionId } from "@/src/design_system/form_elements/option_list/utils/optionListUtils";

const props = withDefaults(defineProps<DSOptionListGroupItemProps>(), {
  listId: undefined,
  activeOptionId: undefined,
});

const modelValue = defineModel<DSOptionListModelValue>();

const slots = useSlots();

const hasSuffixSlot = computed(() => Boolean(slots.suffix));

const isOptionActive = (option: DSBaseListOption): boolean => {
  if (!props.activeOptionId || !props.listId) return false;
  return getOptionId(props.listId, option) === props.activeOptionId;
};
</script>
